import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockInAndOutModel } from "../stockInAndOutModel";
import { momentFormat } from "@/utils/utils";
import { IStockInAndOutField } from "../stockInAndOutType"
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, ioFlag, initPgCfg,
        loadData, setSelectedRowKeys, setDescRows, reset
    } = useStockInAndOutModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData(initPgCfg, { ioFlag })
    }, [])

    useEffect(() => {
        return () => {
            !findNav("9-6") && reset();
        }
    }, [selectedNavId])

    const onRow = (record: IStockInAndOutField) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const columns: ColumnsType<IStockInAndOutField> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1,
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'code',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '所属仓库',
            width: 160,
            dataIndex: 'warehouseName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '所属货位',
            width: 140,
            dataIndex: 'shelfCode',
        }, {
            title: ioFlag ? '入库数量' : '出库数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
        }, {
            title: ioFlag ? '入库金额' : '出库金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '单据类型',
            width: 120,
            dataIndex: 'tradeTypeName',
        }, {
            title: '制单人',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '制单时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '库管员',
            width: 100,
            dataIndex: 'storekeeper',
        }, {
            title: ioFlag ? '入库时间' : '出库时间',
            width: 160,
            dataIndex: 'stockIoTime',
            render: (text) => momentFormat(text)
        }, {
            title: '单位名称',
            width: 180,
            dataIndex: 'userName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        }
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "inOutDetailStatic", "roleCodes": roles };
        return getRoleColumns("inOutDetailStatic", ioFlag === 0 ? "出库记录" : "入库记录", columns, params);
    }, [roles, dataSource]);
    const onRightClick = (record: IStockInAndOutField) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockInAndOutField[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    // setSelectedRowKeys([record.id as string]);
                    onRightClick(record)
                }
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 420px)' }}
        />
    )
}
